<template >
  
    <div id="map" class="divMappa" :style="mapStyle">
    
  </div>
</template>

<script>
//@import "https://unpkg.com/leaflet@1.0.3/dist/leaflet-src.js"

import { userService } from "../services/userServices.js";
import { geoApi } from "../services/GeoApi.js";
import { stradarioApi } from "../services/StradarioApi.js";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import { MarkerClusterGroup } from 'leaflet.markercluster';
import { geoUtils } from "../library/GeoUtils.js";
import { Marker, Map } from "leaflet";

import { rilieviApi } from '../services/RilieviApi.js';
import { rilieviUtils } from '../library/RilieviUtils.js';
//import { router } from '../main.js';

//import "https://unpkg.com/leaflet.markercluster@1.1.0/dist/";
export default {
  props: {

    listaAc: { required: true },
    mapStyle: {
      required: false, default: '', type: String
    }
  },

  data: () => ({
    prgAc: -2,
    context: {
      TYPE: '',
      RILIEVI: 'R',
      CIVICI: 'NC'
    },
    geoJSON: {
      geoBlk: [],
      totalFeature: 0,
      addedFeatures: 0,
      geoJsonLayers: [],
    },

    huge: false,
    lastCurrent: { id: '-1', prgAc: -1, uid: '' },
    markerType: null,



    currentMapZoom: -1,
    clusterOptions: {
      disableClusteringAtZoom: 20,
      showCoverageOnHover: true,
      spiderfyOnMaxZoom: true,
      removeOutsideVisibleBounds: true,

    },

    clusterOptionsCurrent: {
      disableClusteringAtZoom: 11
    },
    clusters: [],
    clusterMain: { prgAc: -1, markers: [] },

    usePopup: false,

    mapNc: { interni: [], foto: [], variazioni: '', msgNc: '' },
    currentNc: { interni: [], foto: [], variazioni: '', msgNc: '' },
    currentAc: { prgAc: -1, fullDes: "please wait ..." },
    openPopup: false,
    markerInfo: { des: '' },
    coreMap: undefined,
    location: { color: "red", text: "Pos. non registrata" },
    mapOptions: { maxZoom: 22, maxNativeZoom: 18, preferCanvas: true },
    iconSize: 64,
    show: true,
    enableTooltip: true,
    zoom: 21,
    defaultMapCenter: [42.46394, 12.30622],
    center: [42.46394, 12.30622],
    geojson: null,
    fillColor: "#e4ce7f",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",

    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

    icons: {
      mapCurrentAc: []
      , mapOtherAc: []
      , mapCurrentNumber: []

    },
    mousePositionControl: null,
    blkInfoControl: null,
    loading: true,
    onError: false,
    currentComune: "xxxx",
    markerClickFunction: null,
    handlePanOrZoomQueue: []

  }),



  mounted() {
    //this.createIcons();
    let compileOnly = false;

    var callback = this.onMarkerClick;
    function localOnMarkerClick(e) {
      if (e) {
          callback(this.feature.properties)

      }
    }

    this.markerClickFunction = localOnMarkerClick;

    if (compileOnly) {
      Marker.$emit();
      Map.$emit();
      MarkerClusterGroup.$emit();
      
      
    }
  },

  methods: {
    saveImage(name, canvas) {
      const link = document.createElement("a");
      link.setAttribute("download", name);
      link.setAttribute(
        "href",
        canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream")
      );
      link.click();
    },
     getMapDiv() {

      var node = document.getElementById('map');
      return node;



     }
    ,
    riposiziona(latLng) {
      setTimeout(() => {
        var zoom = 19;
        this.coreMap.setView(latLng, zoom, {
          animate: true,
          duration: 0.5
        });
      }, 300);
      this.setCenter();


    },


    searchAc(prgAc, ncSearch) {
      if (prgAc == null) {
        prgAc = this.prgAc;

      }

      let zoomL = 19;
      let target = this.getClusterByPrgAc(prgAc);

      if (this.clusterMain.prgAc == prgAc) {
        zoomL = 19;
      } else {
        zoomL = 20;
      }


      if (target != null) {
        let marker = target.markers[0];
        if (this.ncSearch != '') {
          for (let index = 0; index < target.markers.length; index++) {
            if (target.markers[index].des == ncSearch) {
              marker = target.markers[index];

            }
          }
        }
        setTimeout(() => {
          this.coreMap.setView(marker.latLng, zoomL, {
            animate: true,
            duration: 0.5
          });
        }, 1500);


      } else {
        alert(prgAc + ' non trovata sulla mappa');
      }

    },
    getClusterByPrgAc(prgAc) {

      if (this.clusterMain.prgAc == prgAc) {
        return this.clusterMain;
      } else {

        for (let index = 0; index < this.clusters.length; index++) {
          const c = this.clusters[index];

          if (c.prgAc == prgAc) {
            return c;


          }
        }
      }
      return null;
    },


    chkGeo() {

    },
    handlePanOrZoom() {
      var zoom = this.coreMap.getZoom();
      var bounds = this.coreMap.getBounds();
      this.handlePanOrZoomQueue.push({ zoom: zoom, bounds: bounds });

      setTimeout(() => {
        this.doHandlePanOrZoom();
      }, 300);
    },
    doHandlePanOrZoom() {
      let maxIdx = this.handlePanOrZoomQueue.length;
      if (maxIdx == 0) {
        return;
      }
      this.currentMapZoom = this.handlePanOrZoomQueue[maxIdx - 1].zoom;
      let bounds = this.handlePanOrZoomQueue[maxIdx - 1].bounds;
      //pulisco l'array
      this.handlePanOrZoomQueue = [];

      if (this.currentMapZoom < 19) {

        return;
      }

      var minX = bounds._southWest.lng;
      var minY = bounds._southWest.lat;
      var maxX = bounds._northEast.lng;
      var maxY = bounds._northEast.lat;
      var BL = { x: minX, y: minY };
      var TR = { x: maxX, y: maxY };
      this.clusters.forEach(cluster => {
        if (cluster.isOnMap == false) {
          if (geoUtils.intersect(cluster.bottomLeft, cluster.topRight, BL, TR) == true) {

            this.addCluster(cluster);
          }
        }

      });

      //let y=40.685;
      //let x=17.30;
      //let p={x:x,y:y};
      //if (geoUtils.intersect(p, p, BL, TR)==true) {
      // alert('intersect');
      //}
      this.geoJSON.geoBlk.forEach(blk => {
        if (blk.isOnMap == false) {
          /*  g(" blk geo blk=" + JSON.stringify(blk.bottomLeft)+
         " "+JSON.stringify(blk.topRight));*/
          if (geoUtils.intersect(blk.bottomLeft, blk.topRight, BL, TR) == true) {
            // alert("aggiunto blk geo " );
            this.addBlk(blk);
          }

        }
      });
      //
      // var southWest=x._southWest;
      // var northEast=x._northEast;
      //alert(JSON.stringify(southWest));
      //alert(JSON.stringify(northEast));



    },
    createMap() {
      if (this.coreMap) {

        this.coreMap.remove();
      }
      var tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 22, maxNativeZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
      });

      var map = L.map('map', {
        renderer: L.canvas(),
        center: this.center, zoom: 19, maxZoom: 22, maxNativeZoom: 18,
        layers: [tiles]
      });
      this.coreMap = map;
      var _this = this;
      map.on('zoomend', function () {
        _this.handlePanOrZoom();

      });
      map.on("moveend", function () {
        _this.handlePanOrZoom();
      });
      //abilito mouse move
      //map.cursor.enable();
      //

      this.addCluster(this.clusterMain, true);
      if (this.huge == false) {


        for (var i = 0; i < this.clusters.length; i++) {
          this.addCluster(this.clusters[i], false);
        }
      }
      this.creaMouseMoveControl();
      this.createGeoBlkControl();
    },
    createGeoBlkControl() {

      let Position = L.Control.extend({
        _container: null,
        options: {
          position: 'topleft'
        },

        onAdd: function (map) {
          if (map) {
            var latlng = L.DomUtil.create('div', 'blkInfo');
            this._latlng = latlng;
            return latlng;
          }
        },

        updateHTML: function (txt) {
          this._latlng.innerHTML = txt
        }
      });
      this.blkInfoControl = new Position();
      this.coreMap.addControl(this.blkInfoControl);


    },
    creaMouseMoveControl() {

      let Position = L.Control.extend({
        _container: null,
        options: {
          position: 'topleft'
        },

        onAdd: function (map) {
          if (map) {
            var latlng = L.DomUtil.create('div', 'mouseposition');
            this._latlng = latlng;
            return latlng;
          }
        },

        updateHTML: function (txt) {
          this._latlng.innerHTML = txt
        }
      });
      this.mousePositionControl = new Position();
      this.coreMap.addControl(this.mousePositionControl);

    },
    onMarkerClick(prop) {

      if (this.context.TYPE == this.context.CIVICI) {
        stradarioApi.getCivico(prop.id).then((x) => {
          this.mapNc = x.data;
          this.$emit('onMarkerClick', this.mapNc);
        });
      } else {
        var cluster = this.getClusterByPrgAc(prop.prgAc);



        var marker = this.getMarker(cluster, prop.id);
        var desAc = marker.fullDes;

        //rimuovo
        var idx = desAc.indexOf(" ");
        desAc = desAc.slice(idx);
        rilieviApi.getRilieviCollegati(prop.id).then((x) => {

          this.mapNc = rilieviUtils.buildNcFromRilievi(x, null, prop.prgAc, desAc);
          rilieviUtils.getFoto(prop.id).then((foto) => {
            this.mapNc.foto = foto;
            this.$emit('onMarkerClick', this.mapNc);
          });
        });

      }

    },
    removeCluster(aCls) {
      //alert('remove cl:'+JSON.stringify(aCls.prgAc));
      var cluster = null;
      if (this.clusterMain.prgAc == aCls.prgAc) {
        cluster = this.clusterMain;
        this.clusterMain = { prgAc: -1, markers: [] };
      } else {
        for (let index = 0; index < this.clusters.length; index++) {
          const element = this.clusters[index];
          if (element.prgAc == aCls.prgAc) {

            cluster = element;
            this.clusters.splice(index, 1);//elimino dall'array
            break;
          }
        }
      }
      if (cluster.isOnMap == true) {
        cluster.isOnMap = false;
        this.coreMap.removeLayer(cluster.clusterGroupId);
      }

    },
    addMarker(markerClusterGroup, m, isCurrentAc) {
      var title = '';
      var icona = this.getIconaFromMap(isCurrentAc, m.curr, m.des);

      const marKerOptions = { icon: icona, title: title };
      var marker = L.marker(L.latLng(m.latLng[0], m.latLng[1]),
        marKerOptions);
      //salvo id
      m.markerId = marker;
      //testo solo su ac corrente

      marker.bindTooltip(
        "<div  class=" + '"ncTooltip' + '" >' +
        m.fullDes +
        "</div>",
        { permanent: false, sticky: true });

      //proprietà di bind
      marker.feature = {};
      marker.feature.type = 'Feature_';    // Correction, thanks to @Manard82
      marker.feature.properties = {};

      marker.feature.properties.prgAc = m.prgAc;
      marker.feature.properties.id = m.id;
      marker.on('click', this.markerClickFunction);
      //marker.bindTooltip(title);
      markerClusterGroup.addLayer(marker);
    },
    addCluster(cluster, isCurrentAc) {
      var zoomToExplode = 20;
      if (isCurrentAc == true) {
        zoomToExplode = 18;
      }
      var markerClusterGroup = L.markerClusterGroup({
        disableClusteringAtZoom: zoomToExplode,
        maxClusterRadius: 80
      });
      //setto id del gruppo
      cluster.clusterGroupId = markerClusterGroup;


      for (var i = 0; i < cluster.markers.length; i++) {


        var m = cluster.markers[i];
        this.addMarker(markerClusterGroup, m, isCurrentAc);

      }
      this.coreMap.addLayer(markerClusterGroup);
      cluster.isOnMap = true;
    },
    close() {
      this.$emit("close");
    },
    addBlk(blk) {
      //alert('carica geoson'+JSON.stringify(blk.geoJSON));
      geoApi.getGeoJsonByBlkId(blk.blkId).then((geo) => {
        this.caricaGeoJson(geo);
        blk.isOnMap = true;
        this.geoJSON.addedFeatures = this.geoJSON.addedFeatures + blk.featureCount;
        var txt = "<div class='blkInfoTxt'>" + this.geoJSON.addedFeatures + "/" + this.geoJSON.totalFeature + "</div>"
        this.blkInfoControl.updateHTML(txt);
      })


    },
    caricaGeoJson(geo) {
      var myStyle = { "color": "#879582", "weight": 2, "opacity": 0.95 };
      var map = this.coreMap;
      var posControl = this.mousePositionControl;
      var tt = null;
      function f(feature, layer) {
        layer.on('mouseover', function (e) {
          //open popup;
          if (e == '') {
            e = e + '';
          }
          let txt = "<div>Foglio:" +
            feature.properties.FOGLIO +
            "</div><div>Mappale: " +
            feature.properties.NUMERO +
            "</div>";

          posControl.updateHTML(txt, txt)
          if (tt == null) {


            tt = L.tooltip({ permanent: false });
            tt.setLatLng(e.latlng).setContent(txt);
            tt = tt.openOn(map);
            setTimeout(() => {
              map.removeLayer(tt);
              tt = null;
            }, 2500);
          }
        });
      }
      var addGeo = true;
      if (addGeo == true) {
        //alert('addingGeoJson:'+geo);

        var geoLayer = L.geoJson(geo, {
          style: myStyle,
          onEachFeature: f
        });
        geoLayer.addTo(this.coreMap);
        this.geoJSON.geoJsonLayers.push(geoLayer);

      }
    },
    loadGeoJsonAsync() {
      const shapeFile = "fabbricati.shp";
      if (this.huge == true) {
        geoApi.getGeoJsonBlk(shapeFile).then((geoBlk) => {
          // alert(JSON.stringify(geoBlk));
          var count = 0;
          geoBlk.forEach(element => {
            count = count + element.featureCount;

            this.geoJSON.geoBlk.push(element);
          });

          this.geoJSON.totalFeature = count;

        });

      } else {
        geoApi.getGeoJson(shapeFile).then((geo) => {
          this.caricaGeoJson(geo.geoJson);
        });

      }
    },

    updateLayout() {
      this.$forceUpdate();
    },

    getMarker(cluster, id) {
      for (let index = 0; index < cluster.markers.length; index++) {

        if (cluster.markers[index].id == id) {
          return cluster.markers[index];

        }

      }
      return null;
    },
    bindNc(currentNc) {
      this.context.TYPE = this.context.CIVICI;
      this.bind(currentNc);
    },
    bindRilievo(currentNc) {
      this.context.TYPE = this.context.RILIEVI;
      this.bind(currentNc);
    },

    bind(currentNc) {

      this.currentNc = currentNc;
      this.mapNc = currentNc;
      this.prgAc = currentNc.prgAc;
      var cc = userService.getStoreCurrentComune();
      if (this.currentComune == cc) {
        //non è cambiato il numero. mi riposiziono
        if (this.lastCurrent.id == currentNc.id) {
          //rimetto la posizione
          this.coreMap.setView(currentNc.latLng);
        } else if (this.lastCurrent.prgAc == currentNc.prgAc) {
          //tolgo vecchio marker corrente
          var markerOldCurr = this.getMarker(this.clusterMain, this.lastCurrent.id);
          this.clusterMain.clusterGroupId.removeLayer(markerOldCurr.markerId);
          //tolglo nuov marlker corrente 8 cambia l'icona)
          var newMarkerCurr = this.getMarker(this.clusterMain, currentNc.id);
          this.clusterMain.clusterGroupId.removeLayer(newMarkerCurr.markerId);
          markerOldCurr.curr = false;
          newMarkerCurr.curr = true;
          this.addMarker(this.clusterMain.clusterGroupId, markerOldCurr, true);
          this.addMarker(this.clusterMain.clusterGroupId, newMarkerCurr, true);
          //this.removeCluster(this.clusterMain);
          this.coreMap.setView(currentNc.latLng);
          //this.setCurrentLocation(pointOfInterest);
        } else {
          //il vecchio cluster corrente divernerà quello nuovo
          let clusterOtherNew = { id: 'ac_' + this.lastCurrent.prgAc, prgAc: this.lastCurrent.prgAc, markers: [] };
          for (let index = 0; index < this.clusterMain.markers.length; index++) {
            this.clusterMain.markers[index].sel = false;
            clusterOtherNew.markers.push(this.clusterMain.markers[index]);

          }

          this.removeCluster(this.clusterMain);//viene completamente pulito
          var clastuerOther = this.getClusterByPrgAc(currentNc.prgAc);//
          if (clastuerOther != null) {
            //ripluisco il current
            for (let index = 0; index < clastuerOther.markers.length; index++) {
              clastuerOther.markers[index].curr = false;

            }
            this.removeCluster(clastuerOther);
          }
          //riaggiungo il cluster mail
          this.addCluster(clusterOtherNew, false);//la vecchia via corrente viene agginte nelle other
          //recupero e aggiungo il clusterMain
          geoApi.getAcMarkers(currentNc.prgAc, this.context.TYPE).then((x) => {
            var centerTmp = this.consumeMarkers(x.markers);
            this.addCluster(this.clusterMain, true);
            //refresh finale
            this.center = centerTmp;

            //this.coreMap.invalidateSize();
            this.setCenter(centerTmp);
            this.loading = false;
          });

        }
      }
      else {
        this.currentComune = cc;
        //creo la mappa
        this.initMapAndData();


      }
      //this.mappa.show = true;
    },
    escapeNumero(n) {
      return n;
    },
    getIconaFromMap(isCurrentAc, isCurrentNumber, numero) {
      let hashMap = {};
      const base = process.env.VUE_APP_API_URL + '/office/ico/ncico/'

      let imgurl = '';
      let numeroEscaped = this.escapeNumero(numero);
      if (isCurrentNumber == true) {
        imgurl = base + 'CurrentNc/' + numeroEscaped;
        hashMap = this.icons.mapCurrentNumber;
      } else if (isCurrentAc) {
        imgurl = base + 'CurrentAc/' + numeroEscaped;
        hashMap = this.icons.mapCurrentAc;
      } else {
        hashMap = this.icons.mapOtherAc;
        imgurl = base + 'OtherAc/' + numeroEscaped;
      }
      //faccio la ghashMapll'array. non uso le mappe perchè vanno in conflitto con leaflet
      for (let index = 0; index < hashMap.length; index++) {
        if (hashMap[index].key == imgurl) {
          return hashMap[index].value;
        }

      }



      L.Icon.Default.prototype.options = this.icons.iconOther;
      const LeafIcon = L.Icon.extend({
        options: {
          shadowUrl: "",
          iconSize: [38, 60],
          shadowSize: [18, 18],
          iconAnchor: [22, 94],
          shadowAnchor: [4, 62],
          popupAnchor: [-3, -76],
        }
      });
      const url = imgurl;
      const icona = new LeafIcon({ iconUrl: url });
      const item = {};
      item.key = imgurl;
      item.value = icona;
      hashMap.push(item);
      return icona;

    },

    consumeMarkers(x) {
      let idCorrente = this.currentNc.id;
      let prgAcCorrente = this.currentNc.prgAc;
      var centerTmp = this.defaultMapCenter;
      var countMarkers = 0;
      x.forEach((ac) => {
        countMarkers = countMarkers + ac.markers.length;
        let cluster = {
          id: 'ac_' + ac.prgAc, prgAc: ac.prgAc, markers: [],
          bottomLeft: { x: null, y: null }, topRight: { x: null, y: null },

          isOnMap: false
        };
        if (ac.prgAc == prgAcCorrente) {
          this.clusterMain = cluster;
        } else {
          this.clusters.push(cluster);
        }
        var minX = null; var maxX = null; var minY = null; var maxY = null;
        //var maxLng=null;
        ac.markers.forEach((element) => {
          if (!minX || element.latLng[1] < minX) {
            minX = element.latLng[1];
          }
          if (!maxX || element.latLng[1] > maxX) {
            maxX = element.latLng[1];
          }
          //latid
          if (!minY || element.latLng[0] < minY) {
            minY = element.latLng[0];
          }
          if (!maxY || element.latLng[0] > maxY) {
            maxY = element.latLng[0];
          }

          element.fullDes = element.des + ' ' + ac.desAc;
          if (element.id == idCorrente) {
            element.curr = true;
            centerTmp = element.latLng;
            this.lastCurrent.id = idCorrente;
            this.lastCurrent.prgAc = prgAcCorrente;
          }
          cluster.bottomLeft = { x: minX, y: minY };
          cluster.topRight = { x: maxX, y: maxY };


          cluster.markers.push(element);
        });
        if (countMarkers > 2500) {
          this.huge = true;
        }
      });
      return centerTmp;
    },
    initMapAndData() {
      geoApi.getMarkers(this.context.TYPE).then((x) => {
        this.zoom = x.comuInfo.defaultZoom;
        this.center = x.comuInfo.center;
        this.defaultMapCenter = x.comuInfo.center;
        var centerTmp = this.consumeMarkers(x.markers);

        //refresh finale
        this.center = centerTmp;
        this.createMap();
        //this.coreMap.invalidateSize();
        this.setCenter(centerTmp);
        this.loading = false;
      }).then(() => {
        //asincrono
        this.loadGeoJsonAsync();
      });
    },
    setCurrentLocation(newPoint) {
      //devo cambiare icona
      if (this.lastCurrent.id == newPoint.id) {
        this.coreMap.setView(newPoint.latLng, {
          animate: true,
          duration: 0.5
        });
      }




    },
    setCenter(center) {
      if (center == undefined || center.length < 2) {
        center = this.defaultMapCenter;
      }
      setTimeout(() => {
        this.coreMap.invalidateSize();
        this.coreMap.panTo(center);
        this.updateLayout();
      }, 500);

    },


  },
};
</script>
<style scoped >
@import "https://unpkg.com/leaflet@1.0.3/dist/leaflet.css";
@import "https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.css";
@import "https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style >
.item {
  color: wheat;
}

.itemContainer {
  background-color: black;
  width: 20rem;
}


.divMappa {
  z-index: 100;
  margin: 0rem;
  padding: 0rem;


}

.tableLocProp td {
  border: 0px solid gray;
  padding-top: 0.3rem;
  padding-right: 0.2rem;
  text-align: left;
  font-size: 0.8rem;

}

button.itemHeader,
button.v-expansion-panel-header.itemHeader.v-expansion-panel-header--active {
  border: 0px solid yellow;
  padding-top: 2px !important;
  ;
  padding-bottom: 2px !important;

  min-height: 2rem;

}

.itemHeader {
  background-color: cadetblue;
}

._leaflet-tooltip {
  min-width: 12px;
  min-height: 5px;
  top: -40px;
  background: transparent !important;
  border: 0px !important;
  font-weight: bold;
  position: absolute;
}

.ncTooltip {
  font-weight: 600;
  padding: 0.4rem;
}

.interno,
.ncChip {
  margin-right: 0.3rem;
}

.fotoCount {

  padding-left: 1rem;
  width: 100%;
}

.acSearch {
  width: 25rem;
  height: 2rem;
  margin-top: 1rem;
}

.ncSearch {
  margin-top: 1rem !important;
  ;
  margin-left: 1rem;
  height: 2rem !important;
  ;
}

.leaflet-control.mouseposition {
  width: 4rem !important;
  min-width: 6rem;
  min-height: 2.8rem;
  position: absolute !important;

  top: 20px;
  left: 38px;
  font-size: 11px !important;
  padding: 3px;
  color: black;

  background-color: white;
  border: 2px solid lightgray !important;

}

.riposiziona {
  padding: 0;
  border: 0px solid red;
  height: 2rem;
  margin: 1rem;
  margin-right: 2rem;
}

.geoBlkTotal {
  font-size: 0.6rem;
  margin-top: 2.5rem;
}

.blkInfo {

  color: black;
  position: absolute !important;
  ;
  top: 1px;
  left: 38px;
  font-size: 9px;
  width: 6rem;
  padding: 1px;
  border: 0px solid gray;
}
</style>

